// src/portals/fan/pages/DiscoverPage/components/creatorPreview/DonationCampaignCard.js
import React, { useState } from "react";
import Card from "../../../../../../components/ui/Card";
import Button from "../../../../../../components/ui/Button";
import CheckoutModal from "../../../../../../components/shared/CheckoutModal";
import DonationAmountModal from "../../../../../../components/shared/DonationAmountModal"; // ✨ 1. Import the new modal
import { Heart } from "lucide-react";

const DonationCampaignCard = ({ campaign }) => {
  const [isAmountModalOpen, setAmountModalOpen] = useState(false); // State for the amount modal
  const [isCheckoutOpen, setCheckoutOpen] = useState(false); // State for the checkout modal
  const [finalAmount, setFinalAmount] = useState(0); // State to hold the chosen amount

  const progressPercentage = (campaign.raisedETB / campaign.goalETB) * 100;

  // This function will be called by the DonationAmountModal
  const handleAmountSelected = (amount) => {
    setFinalAmount(amount); // Store the amount
    setAmountModalOpen(false); // Close the amount modal
    setCheckoutOpen(true); // Immediately open the checkout modal
  };

  // The item for the final checkout modal will now use the selected amount
  const itemForCheckout = {
    ...campaign,
    name: campaign.title,
    priceETB: finalAmount, // Use the state variable
    type: "Donation",
  };

  return (
    <>
      <Card>
        <h3 className="font-bold text-lg text-text-primary">
          {campaign.title}
        </h3>
        <p className="text-sm text-text-secondary">by {campaign.beneficiary}</p>
        <div className="mt-4">
          <div className="w-full bg-slate-200 rounded-full h-2">
            <div
              className="bg-secondary h-2 rounded-full"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
          <div className="flex justify-between text-xs mt-1">
            <span className="font-semibold text-secondary">
              {campaign.raisedETB.toLocaleString()} ETB Raised
            </span>
            <span className="text-text-secondary">
              Goal: {campaign.goalETB.toLocaleString()} ETB
            </span>
          </div>
        </div>

        {/* ✨ This button now opens the AMOUNT modal */}
        <Button
          onClick={() => setAmountModalOpen(true)}
          variant="secondary"
          size="md"
          className="w-full mt-4"
        >
          <Heart size={16} className="mr-2" />
          Donate
        </Button>
      </Card>

      {/* ✨ Render BOTH modals, controlled by their own state */}
      <DonationAmountModal
        isOpen={isAmountModalOpen}
        onClose={() => setAmountModalOpen(false)}
        onContinue={handleAmountSelected}
        campaign={campaign}
      />
      <CheckoutModal
        isOpen={isCheckoutOpen}
        onClose={() => setCheckoutOpen(false)}
        item={itemForCheckout}
      />
    </>
  );
};

export default DonationCampaignCard;
